import { Controller, useFormContext } from "react-hook-form";

import { CreateConnectionGrid } from "src/connections/CreateConnectionGrid";
import { ProviderSelectInputs } from "src/connections/types";

type Props = {
  onSubmit: (data: ProviderSelectInputs) => void;
};

export const ProviderSelectForm: React.FC<Props> = ({ onSubmit }) => {
  const { control, handleSubmit, setValue } =
    useFormContext<ProviderSelectInputs>();
  return (
    <form data-loc="select-provider-form" onSubmit={handleSubmit(onSubmit)}>
      <Controller
        control={control}
        name="provider"
        render={({ field: { onChange } }) => (
          <CreateConnectionGrid
            onProviderSelect={(provider, isManifestProvider) => {
              onChange(provider);
              setValue("isManifestProvider", isManifestProvider);
              handleSubmit(onSubmit)();
            }}
          />
        )}
      />
    </form>
  );
};
